document.documentElement.classList.remove('no-js');
(function(){
  const details = document.querySelectorAll('.faq-item');
  details.forEach((item)=>item.addEventListener('toggle',()=>{
    if(item.open){ details.forEach((other)=>{ if(other!==item) other.open=false; }); }
  }));
})();



/* KSS Hybrid homepage motion */
(function(){
  const loader = document.querySelector('[data-archive-loader]');
  if (loader) {
    let seen = false;
    try { seen = sessionStorage.getItem('kssArchiveIntroSeen') === '1'; } catch(e) {}
    const hideLoader = function(){
      loader.classList.add('is-hidden');
      loader.hidden = true;
      try { sessionStorage.setItem('kssArchiveIntroSeen', '1'); } catch(e) {}
    };
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const earlyLoad = window.performance && window.performance.now() < 500;
    if (seen || reducedMotion || !earlyLoad || window.matchMedia('(max-width: 720px)').matches) hideLoader();
    else {
      window.setTimeout(hideLoader, 450);
      loader.hidden = false;
    }
  }
  const reveals = document.querySelectorAll('.template-index .reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    const io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){ if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); } });
    }, { threshold: 0.12 });
    reveals.forEach(function(el){ io.observe(el); });
  } else {
    reveals.forEach(function(el){ el.classList.add('is-visible'); });
  }
  if (document.body.classList.contains('template-index') && window.matchMedia('(pointer:fine)').matches && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    let mouseFrame = 0;
    document.addEventListener('mousemove', function(event){
      if (mouseFrame) return;
      mouseFrame = requestAnimationFrame(function(){
        document.documentElement.style.setProperty('--mx', event.clientX + 'px');
        document.documentElement.style.setProperty('--my', event.clientY + 'px');
        mouseFrame = 0;
      });
    }, { passive: true });
  }
})();


(function () {
  const key = 'kssWishlistV1';
  let strings = { save: 'Save to wishlist', saved: 'Saved to wishlist', view: 'View item', remove: 'Remove', default_title: 'Saved product' };
  try { strings = Object.assign(strings, JSON.parse(document.querySelector('[data-wishlist-config]').textContent)); } catch (error) {}
  let memory = [];
  let storageAvailable = true;
  let returnFocus = null;
  let closeTimer = null;
  let restoreWishlistFocus = false;
  const cleanItems = function (items) {
    const seen = new Set();
    return (Array.isArray(items) ? items : []).filter(function (item) {
      if (!item || typeof item !== 'object' || !/^\d+$/.test(String(item.id || '')) || seen.has(String(item.id))) return false;
      seen.add(String(item.id));
      return true;
    }).slice(0, 80).map(function (item) {
      return { id: String(item.id), title: String(item.title || strings.default_title).slice(0, 500), url: String(item.url || '#'), image: String(item.image || ''), price: String(item.price || '').slice(0, 100) };
    });
  };
  const read = function () {
    if (storageAvailable) {
      try { memory = cleanItems(JSON.parse(localStorage.getItem(key) || '[]')); } catch (error) { storageAvailable = false; }
    }
    return memory;
  };
  const write = function (items) {
    memory = cleanItems(items);
    if (storageAvailable) { try { localStorage.setItem(key, JSON.stringify(memory)); } catch (error) { storageAvailable = false; } }
  };
  const escapeHtml = function (value) { return String(value || '').replace(/[&<>'"]/g, function (char) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[char]; }); };
  const safeUrl = function (value, fallback, sameOrigin) {
    try {
      const url = new URL(String(value || ''), window.location.origin);
      if (!['http:', 'https:'].includes(url.protocol) || (sameOrigin && url.origin !== window.location.origin)) return fallback;
      return escapeHtml(url.href);
    } catch (error) { return fallback; }
  };
  const itemMarkup = function (item) {
    const image = safeUrl(item.image, '', false);
    return '<article class="kss-wishlist-item" data-wishlist-item="' + item.id + '">' + (image && item.image ? '<img src="' + image + '" alt="' + escapeHtml(item.title) + '" loading="lazy" decoding="async" width="100" height="100">' : '<div class="kss-wishlist-item__placeholder"></div>') + '<div><h3>' + escapeHtml(item.title) + '</h3>' + (item.price ? '<p>' + escapeHtml(item.price) + '</p>' : '') + '<div class="kss-wishlist-item__actions"><a class="kss-wishlist-item__view" href="' + safeUrl(item.url, '#', true) + '">' + escapeHtml(strings.view) + ' <span aria-hidden="true">↗</span></a><button class="kss-wishlist-item__remove" type="button" data-wishlist-remove="' + item.id + '">' + escapeHtml(strings.remove) + '</button></div></div></article>';
  };
  const render = function () {
    const items = read();
    const active = document.activeElement;
    const oldButtons = Array.from(document.querySelectorAll('[data-wishlist-remove]'));
    const oldIndex = oldButtons.indexOf(active);
    document.querySelectorAll('[data-wishlist-count]').forEach(function (node) { node.textContent = String(items.length); });
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (button) {
      const saved = items.some(function (item) { return item.id === button.dataset.wishlistId; });
      button.classList.toggle('is-saved', saved);
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      const label = button.querySelector('[data-wishlist-label]');
      if (label) label.textContent = saved ? strings.saved : strings.save;
    });
    const markup = items.map(itemMarkup).join('');
    document.querySelectorAll('[data-wishlist-list], [data-wishlist-page-list]').forEach(function (list) { list.innerHTML = markup; list.hidden = !items.length; });
    document.querySelectorAll('[data-wishlist-empty], [data-wishlist-page-empty]').forEach(function (empty) { empty.hidden = Boolean(items.length); });
    document.querySelectorAll('[data-wishlist-clear]').forEach(function (button) { button.disabled = !items.length; });
    if (oldIndex >= 0) {
      const buttons = Array.from(document.querySelectorAll('[data-wishlist-remove]'));
      const next = buttons[Math.min(oldIndex, buttons.length - 1)] || document.querySelector('button[data-wishlist-close]') || document.querySelector('[data-wishlist-page-empty] a');
      if (next) next.focus({ preventScroll: true });
    }
  };
  const open = function () {
    const shell = document.querySelector('[data-wishlist-shell]');
    if (!shell) return;
    document.dispatchEvent(new CustomEvent('kss:overlay-open', { detail: { type: 'wishlist' } }));
    clearTimeout(closeTimer);
    returnFocus = document.activeElement;
    shell.dataset.wishlistState = 'true';
    render();
    shell.hidden = false;
    shell.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      if (shell.dataset.wishlistState !== 'true') return;
      shell.classList.add('is-open');
      document.documentElement.classList.add('wishlist-open');
      const button = shell.querySelector('button[data-wishlist-close]');
      if (button) button.focus({ preventScroll: true });
    });
  };
  const close = function (restoreFocus) {
    const shell = document.querySelector('[data-wishlist-shell]');
    if (!shell || shell.dataset.wishlistState !== 'true') { if (restoreFocus === false) restoreWishlistFocus = false; return; }
    restoreWishlistFocus = restoreFocus !== false;
    clearTimeout(closeTimer);
    shell.dataset.wishlistState = 'false';
    shell.classList.remove('is-open');
    document.documentElement.classList.remove('wishlist-open');
    closeTimer = setTimeout(function () {
      if (shell.dataset.wishlistState === 'true') return;
      shell.hidden = true;
      shell.setAttribute('aria-hidden', 'true');
      if (restoreWishlistFocus && returnFocus && returnFocus.isConnected) returnFocus.focus({ preventScroll: true });
    }, 260);
  };
  document.addEventListener('click', function (event) {
    const toggle = event.target.closest('[data-wishlist-toggle]');
    if (toggle) {
      event.preventDefault();
      const item = { id: toggle.dataset.wishlistId, title: toggle.dataset.wishlistTitle, url: toggle.dataset.wishlistUrl, image: toggle.dataset.wishlistImage, price: toggle.dataset.wishlistPrice };
      if (!/^\d+$/.test(String(item.id || ''))) return;
      const items = read();
      write(items.some(function (saved) { return saved.id === item.id; }) ? items.filter(function (saved) { return saved.id !== item.id; }) : [item].concat(items));
      render();
    } else if (event.target.closest('[data-wishlist-open]')) { event.preventDefault(); open(); }
    else if (event.target.closest('[data-wishlist-close]')) { event.preventDefault(); close(); }
    else if (event.target.closest('[data-wishlist-remove]')) { event.preventDefault(); const id = event.target.closest('[data-wishlist-remove]').dataset.wishlistRemove; write(read().filter(function (item) { return item.id !== id; })); render(); }
    else if (event.target.closest('[data-wishlist-clear]')) { event.preventDefault(); write([]); render(); }
  });
  document.addEventListener('kss:overlay-open', function (event) { if (event.detail && event.detail.type !== 'wishlist') close(false); });
  document.addEventListener('keydown', function (event) {
    const shell = document.querySelector('[data-wishlist-shell]');
    if (!shell || shell.dataset.wishlistState !== 'true') return;
    if (event.key === 'Escape') { event.preventDefault(); close(); }
    else if (event.key === 'Tab') {
      const focusable = Array.from(shell.querySelectorAll('a, button, [tabindex="0"]')).filter(function (node) { return !node.disabled && node.getClientRects().length; });
      const first = focusable[0]; const last = focusable[focusable.length - 1];
      if (!first) return;
      if (event.shiftKey && (document.activeElement === first || !shell.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !shell.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
    }
  });
  document.addEventListener('DOMContentLoaded', render);
  document.addEventListener('shopify:section:load', render);
  window.addEventListener('storage', function (event) { if (event.key === key) render(); });
  render();
})();


/* KSS header popovers, localization controls, mobile search, and UX helpers */
(function(){

  let closeTimer = null;
  const panelCloseTimers = new WeakMap();
  const panelFocusTimers = new WeakMap();
  const panelTriggers = new WeakMap();
  const panelRestoreFocus = new WeakMap();

  function syncScrollTopButtons(){
    const threshold = Math.max(420, window.innerHeight * 0.65);
    const visible = window.scrollY > threshold;
    document.querySelectorAll('[data-kss-scroll-top]').forEach(function(button){
      button.classList.toggle('is-visible', visible);
      button.setAttribute('aria-hidden', visible ? 'false' : 'true');
      button.tabIndex = visible ? 0 : -1;
    });
  }

  function activePanels(){
    return Array.from(document.querySelectorAll('[data-kss-popover-panel]')).filter((panel) => !panel.hidden);
  }

  function setOverlay(visible){
    const overlay = document.querySelector('[data-kss-popover-overlay]');
    if (!overlay) return;
    clearTimeout(closeTimer);
    if (visible) {
      overlay.hidden = false;
      requestAnimationFrame(() => overlay.classList.add('is-visible'));
      document.documentElement.classList.add('kss-popover-open');
    } else {
      overlay.classList.remove('is-visible');
      document.documentElement.classList.remove('kss-popover-open');
      closeTimer = setTimeout(() => {
        if (!activePanels().length) overlay.hidden = true;
      }, 190);
    }
  }

  function closePanel(panel, restoreFocus){
    if (!panel || panel.hidden) return;
    if (panel.dataset.kssPanelOpen === 'false') { if (!restoreFocus) panelRestoreFocus.set(panel, false); return; }
    panelRestoreFocus.set(panel, Boolean(restoreFocus));
    clearTimeout(panelCloseTimers.get(panel));
    clearTimeout(panelFocusTimers.get(panel));
    panel.dataset.kssPanelOpen = 'false';
    panel.classList.remove('is-open');
    const wrap = panel.closest('.header-popover-wrap');
    const trigger = wrap && wrap.querySelector('[data-kss-popover-toggle]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    panelCloseTimers.set(panel, setTimeout(() => { if (panel.dataset.kssPanelOpen === 'true') return; panel.hidden = true; setOverlay(activePanels().length > 0); const trigger = panelTriggers.get(panel); if (panelRestoreFocus.get(panel) && trigger && trigger.isConnected && trigger.getClientRects().length) trigger.focus({ preventScroll: true }); }, 170));
  }

  function closePopovers(exceptWrap, restoreFocus){
    document.querySelectorAll('[data-kss-popover-panel]').forEach(function(panel){
      const wrap = panel.closest('.header-popover-wrap');
      if (exceptWrap && wrap === exceptWrap) return;
      closePanel(panel, restoreFocus);
    });
    if (!exceptWrap) setOverlay(false);
  }

  function openPanel(panel, trigger){
    if (!panel) return;
    document.dispatchEvent(new CustomEvent('kss:overlay-open', { detail: { type: 'popover' } }));
    clearTimeout(panelCloseTimers.get(panel));
    clearTimeout(panelFocusTimers.get(panel));
    panel.dataset.kssPanelOpen = 'true';
    if (trigger) panelTriggers.set(panel, trigger);
    panel.hidden = false;
    requestAnimationFrame(() => { if (panel.dataset.kssPanelOpen === 'true') panel.classList.add('is-open'); });
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    setOverlay(true);
    const focusTarget = panel.querySelector('[data-kss-popover-close], input, select, button, a');
    if (focusTarget) panelFocusTimers.set(panel, setTimeout(() => { if (panel.dataset.kssPanelOpen === 'true') focusTarget.focus({ preventScroll: true }); }, 80));
  }

  function openModal(name){
    const modal = document.querySelector('[data-kss-modal="' + name + '"]');
    if (!modal) return;
    modal.hidden = false;
    document.documentElement.classList.add('kss-modal-open');
    const input = modal.querySelector('input, select, textarea, button');
    if (input) setTimeout(function(){ input.focus(); }, 80);
  }

  function closeModals(){
    document.querySelectorAll('[data-kss-modal]').forEach(function(modal){ modal.hidden = true; });
    document.documentElement.classList.remove('kss-modal-open');
  }

  document.addEventListener('click', function(event){
    const popoverTrigger = event.target.closest('[data-kss-popover-toggle]');
    if (popoverTrigger) {
      event.preventDefault();
      const wrap = popoverTrigger.closest('.header-popover-wrap');
      const panel = wrap && wrap.querySelector('[data-kss-popover-panel]');
      if (!panel) return;
      const willOpen = panel.hidden || panel.dataset.kssPanelOpen === 'false';
      closePopovers(wrap);
      if (willOpen) openPanel(panel, popoverTrigger);
      else closePanel(panel, true);
      return;
    }

    if (event.target.closest('[data-kss-popover-close]')) {
      event.preventDefault();
      const panel = event.target.closest('[data-kss-popover-panel]');
      closePanel(panel, true);
      return;
    }

    if (event.target.closest('[data-kss-popover-overlay]')) {
      event.preventDefault();
      event.stopPropagation();
      closePopovers();
      closeModals();
      return;
    }

    if (!event.target.closest('.header-popover-wrap') && !event.target.closest('[data-kss-popover-panel]')) {
      closePopovers();
    }

    const modalOpen = event.target.closest('[data-kss-modal-open]');
    if (modalOpen) {
      event.preventDefault();
      openModal(modalOpen.dataset.kssModalOpen);
      return;
    }

    if (event.target.closest('[data-kss-modal-close]')) {
      event.preventDefault();
      closeModals();
      return;
    }

    const scrollTop = event.target.closest('[data-kss-scroll-top]');
    if (scrollTop) {
      event.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });

  document.addEventListener('kss:overlay-open', function(event){
    if (event.detail && event.detail.type !== 'popover') { closePopovers(); closeModals(); }
  });

  document.querySelectorAll('[data-kss-header-search]').forEach(function(form){
    const input = form.querySelector('input[name="q"]');
    form.addEventListener('submit', function(event){
      if (!input || !input.value.trim()) {
        event.preventDefault();
        if (input) input.focus();
      }
    });
  });

  document.addEventListener('keydown', function(event){
    if (event.key === 'Tab') {
      const panel = activePanels().find(function (node) { return node.dataset.kssPanelOpen === 'true'; });
      if (panel) {
        const nodes = Array.from(panel.querySelectorAll('a, button, input, select, textarea, [tabindex="0"]')).filter(function (node) { return !node.disabled && node.getClientRects().length; });
        const first = nodes[0]; const last = nodes[nodes.length - 1];
        if (first && event.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
        else if (first && !event.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
      }
    }
    if (event.key === 'Escape') {
      closePopovers(null, true);
      closeModals();
    }
  });

  window.addEventListener('scroll', syncScrollTopButtons, { passive: true });
  window.addEventListener('resize', syncScrollTopButtons);
  syncScrollTopButtons();
})();

/* KSS mobile collection grid toggle */
(function(){
  const STORAGE_KEY = 'kssCollectionMobileGrid';
  document.querySelectorAll('[data-collection-section]').forEach(function(section){
    const buttons = Array.from(section.querySelectorAll('[data-grid-view]'));
    if (!buttons.length) return;

    const apply = function(mode){
      const safeMode = mode === 'one' ? 'one' : 'two';
      section.dataset.mobileGrid = safeMode;
      section.querySelectorAll('.product-card__media img[srcset]').forEach(function (image) { image.sizes = (safeMode === 'one' ? '(max-width: 768px) calc(100vw - 24px), ' : '(max-width: 768px) calc((100vw - 38px) / 2), ') + '(max-width: 990px) 33vw, 25vw'; });
      buttons.forEach(function(button){
        const active = button.dataset.gridView === safeMode;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      try { localStorage.setItem(STORAGE_KEY, safeMode); } catch(e) {}
    };

    let saved = 'two';
    try { saved = localStorage.getItem(STORAGE_KEY) || 'two'; } catch(e) {}
    apply(saved);

    buttons.forEach(function(button){
      button.addEventListener('click', function(){ apply(button.dataset.gridView); });
    });
  });
})();

/* KSS draggable mobile scroll helper */
(function(){
  const control = document.querySelector('[data-kss-scroll-control]');
  const thumb = document.querySelector('[data-kss-scroll-thumb]');
  if (!control || !thumb) return;

  let dragging = false;
  let startY = 0;
  let startScroll = 0;

  const maxScroll = () => Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
  const maxThumb = () => Math.max(1, control.clientHeight - thumb.offsetHeight);

  function updateThumb(){
    if (dragging) return;
    const progress = window.scrollY / maxScroll();
    const y = Math.max(0, Math.min(maxThumb(), progress * maxThumb()));
    thumb.style.transform = 'translate(-50%, ' + y + 'px)';
    const shouldShow = maxScroll() >= 240 && window.scrollY > Math.max(520, window.innerHeight * 0.7);
    control.hidden = !shouldShow;
    control.classList.toggle('is-visible', shouldShow);
  }

  function dragTo(clientY){
    const dy = clientY - startY;
    const scroll = startScroll + (dy / maxThumb()) * maxScroll();
    window.scrollTo(0, Math.max(0, Math.min(maxScroll(), scroll)));
  }

  thumb.addEventListener('pointerdown', function(event){
    dragging = true;
    startY = event.clientY;
    startScroll = window.scrollY;
    thumb.setPointerCapture(event.pointerId);
    event.preventDefault();
  });

  thumb.addEventListener('pointermove', function(event){
    if (!dragging) return;
    dragTo(event.clientY);
  });

  thumb.addEventListener('pointerup', function(event){
    dragging = false;
    try { thumb.releasePointerCapture(event.pointerId); } catch(e) {}
    updateThumb();
  });

  window.addEventListener('scroll', updateThumb, { passive: true });
  window.addEventListener('resize', updateThumb);
  document.addEventListener('DOMContentLoaded', updateThumb);
  updateThumb();
})();

document.addEventListener('shopify:section:load', function (event) {
  if (event.target.matches('.reveal')) event.target.classList.add('is-visible');
  event.target.querySelectorAll('.reveal').forEach(function (node) { node.classList.add('is-visible'); });
});
